import {
  QueryClientProvider as OriginQueryClientProvider,
  type QueryClientProviderProps
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type FC } from 'react'

import { queryClient } from './query-client'

const devtoolsIsEnabled =
  import.meta.env.VITE_REACT_QUERY_DEVTOOLS_ENABLED === 'true'

export const QueryClientProvider: FC<
  Omit<QueryClientProviderProps, 'client'>
> = ({ children }) => {
  return (
    <OriginQueryClientProvider client={queryClient}>
      {children}
      {devtoolsIsEnabled && <ReactQueryDevtools />}
    </OriginQueryClientProvider>
  )
}
